/**
 * What the junction screens hold before the first /summary answer arrives, or when the API cannot be reached:
 * no checkpoints and no counts. Screens must never show sample figures as if they were live.
 */
export const EMPTY_SUMMARY = { server_time: 0, reporting_start: 0, headline: {}, checkpoints: {}, groups: [] };
